import { Message } from "@JohnLewisPartnership/jl-design-system/dist/components/message/v2/Message";
const inStoreOnlyMessage: string = "Available in-store only";

type Props = {
  isInStoreOnly: boolean;
};

export const InStoreOnlyMessageBoxUI = ({ isInStoreOnly }: Props) =>
  isInStoreOnly ? <Message type="warning" title={inStoreOnlyMessage} /> : null;
